import "./App.css";
import Slide from "./Component/Slide";
import "./App.css";

function App() {
  return (
    <div className="App container">
      <Slide />
    </div>
  );
}

export default App;
